import { useQuery } from "@tanstack/react-query";
import { ProposalsResource } from "@repo/core/services/resources/proposals";
import { apiInstance } from "@repo/core/services/instances/api";
import { useMemo } from "react";
import { ProposalProduct } from "@repo/core/types/proposals";
import { mapSelectableProducts } from "./utils";

const proposalsResource = new ProposalsResource(apiInstance);

export const useMapperProducts = () => {
  const { data: productsData, isFetching: isFetchingProducts } = useQuery({
    queryKey: ["products"],
    queryFn: () => proposalsResource.getProducts(),
    select: (data) => data.data
  });

  const products: ProposalProduct[] = useMemo(
    () => mapSelectableProducts(productsData),
    [productsData]
  );

  return {
    products,
    isFetchingProducts
  };
};
